// extracted by mini-css-extract-plugin
export var indeterminate = "_4y-5";
export var md = "_4y-4";
export var semantic = "_4y-6";
export var sm = "_4y-3";
export var text = "_4y-7";
export var toggleInput = "_4y-0";
export var toggleSwitch = "_4y-1";
export var xs = "_4y-2";